import { defineStore } from 'pinia';
import { validatePhoneNumber } from '../utils/phoneNumber';
import * as LoginApi from '../api/loginApi';
import { LoginError } from '../types/loginError';
import { CustomerData } from '../types/session';
import Segment from '../Segment';

interface AuthenticationState {
  loading: boolean;
}

export const useAuthenticationStore = defineStore('authentication', {
  state: (): AuthenticationState => ({
    loading: false,
  }),
  actions: {
    async authenticate(phoneNumber: string, code: string): Promise<Partial<CustomerData>> {
      this.loading = true;
      try {
        const result = await LoginApi.authenticate({ phoneNumber, code });
        Segment.trackUserGot('Authentication_Success');
        return result;
      } finally {
        this.loading = false;
      }
    },
    async generateCode(phoneNumber: string, force = false): Promise<void> {
      this.loading = true;
      try {
        if (!validatePhoneNumber(phoneNumber)) {
          throw LoginError.INVALID_PHONE_NUMBER;
        }
        await LoginApi.generateCode({ phoneNumber, force });
      } finally {
        this.loading = false;
      }
    },
  },
});
